import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled || !isHomePage ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">🐾</span>
          <span className="logo-text">The Pet Nanny of Weston</span>
        </Link>

        <button 
          className="navbar-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle navigation"
        >
          <span className="hamburger"></span>
        </button>

        <a href="tel:954-560-6839" className="navbar-phone">
          <PhoneIcon /> <span className="phone-text">954-560-6839</span>
        </a>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <Link 
              to="/" 
              className={`navbar-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/meet-suzi" 
              className={`navbar-link ${isActive('/meet-suzi') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Meet Suzanne
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/pricing" 
              className={`navbar-link ${isActive('/pricing') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/booking" 
              className={`navbar-link ${isActive('/booking') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Book Now
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/forms" 
              className={`navbar-link ${isActive('/forms') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Forms
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
